import React, { useEffect, useState } from 'react';
import { Repeat, Scale, ChevronUp } from 'lucide-react';
import { cartAPI } from '../services/api';
import ProductCard from './ProductCard';
import EquivalentsCompareTable from './EquivalentsCompareTable';
import { Button } from './ui/button';
import { useT } from '../services/i18n';

const EquivalentProducts = ({ product, data }) => {
  const { t } = useT();
  const [adding, setAdding] = useState(null);
  const [compare, setCompare] = useState(true);

  useEffect(() => { setCompare(true); }, [product.id]);

  if (!data?.items?.length) return null;
  const addToCart = async (id) => { setAdding(id); try { await cartAPI.addItem(id); } finally { setAdding(null); } };
  const brands = [...new Set(data.items.map(p => p.brand))];
  const cheaper = data.items.filter(p => p.price < product.price).length;

  return (
    <section id="equivalent-products" className="mt-8 scroll-mt-24" data-testid="equivalent-products">
      <div className="flex items-center justify-between mb-3 flex-wrap gap-2">
        <div>
          <h2 className="text-lg font-bold text-gray-900 flex items-center gap-2"><Repeat size={18} className="text-blue-600" /> {t('equiv.title')}</h2>
          <p className="text-sm text-gray-500" data-testid="equivalent-products-count">{t('equiv.count', { n: data.items.length, count: data.items.length })} · {brands.join(', ')}{cheaper ? t('equiv.cheaper', { n: cheaper, count: cheaper }) : ''}</p>
        </div>
        <Button variant="outline" onClick={() => setCompare(v => !v)} data-testid="equivalents-compare-button" className="border-blue-300 text-blue-700 hover:bg-blue-50">
          {compare ? <ChevronUp size={16} className="mr-2" /> : <Scale size={16} className="mr-2" />} {compare ? t('equiv.hideCompare') : t('equiv.compare', { n: data.items.length + 1 })}
        </Button>
      </div>
      {compare && <div className="mb-6"><EquivalentsCompareTable current={product} items={data.items} /></div>}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {data.items.map(p => <ProductCard key={p.id} product={p} onAddToCart={addToCart} isAdding={adding === p.id} />)}
      </div>
    </section>
  );
};

export default EquivalentProducts;
